import { SectionContainer } from "@affinity/components/Section";
import { Section } from "@affinity/components/Section";
import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import CreateAccount from "@affinity/Handlers/CreateAccount";
import { CustomState } from "@affinity/Store/Reducers";
import Zone from "@insite/client-framework/Components/Zone";
import Button from "@insite/mobius/Button";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: CustomState) => ({
    // Map required state elements to component properties
});

const mapDispatchToProps = {
    // Map loader and setter methods to component properties
};

type Step3CompleteProps = {
    contentId: string;
};
type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & Step3CompleteProps;

export const Step3Complete: React.FC<Props> = ({ contentId }) => {
    function submit() {}

    return (
        <Section shouldFocus={true}>
            <Main>
                <Zone contentId={contentId} zoneName="Step3Button" requireRows={false} />
            </Main>
            <Zone contentId={contentId} zoneName="AffinitySidebar" requireRows={false} />
        </Section>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Step3Complete);

// const Section = styled(SectionContainer)`
//     color: ${colours.black};
//     @media (min-width: ${breakpointWidth("md")}) {
//         display: flex;
//         flex-direction: row;
//     }
// `;

const Main = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex: 0 0 55%;
    gap: ${rem(10)};
    p {
        font-size: ${rem(18)};
        @media (min-width: ${breakpointWidth("lg")}) {
            font-size: ${rem(20)};
        }
    }
`;

const Title = styled.p`
    font-size: ${rem(24)};
`;

const Info = styled.p`
    font-size: ${rem(18)};
`;
